export const ALTERA_PERSONALIZACAO_REQUEST = 'ALTERA_PERSONALIZACAO_REQUEST';
export const ALTERA_PERSONALIZACAO_SUCCESS = 'ALTERA_PERSONALIZACAO_SUCCESS';
export const RECUPERA_PERSONALIZACAO_REQUEST =
  'RECUPERA_PERSONALIZACAO_REQUEST';
export const RECUPERA_PERSONALIZACAO_SUCCESS =
  'RECUPERA_PERSONALIZACAO_SUCCESS';
